module.exports = __webpack_public_path__ + "img/desktop/Background/background@1x.jpg?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/desktop/Background/background@1x.jpg
// module id = 545
// module chunks = 0